import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const renewalWordList = [
  "alive",
  "balance",
  "begin",
  "breathe",
  "bright",
  "calm",
  "change",
  "clarity",
  "clear",
  "dawn",
  "dream",
  "energy",
  "focus",
  "forward",
  "ground",
  "journey",
  "path",
  "plan",
  "prepare",
  "present",
  "progress",
  "quiet",
  "ready",
  "reflect",
  "resilient",
  "root",
  "start",
  "steady",
  "step",
  "strong",
  "transform",
  "vision",
];

export const renewalCollection: WordCollection = createCollection(
  "renewal",
  "Renewal & Reflection",
  renewalWordList,
  {
    icon: "sunrise",
    isWordlistViewable: true,
    startDate: new Date(new Date().getFullYear(), 0, 1), // January 1st
    endDate: new Date(new Date().getFullYear(), 0, 20), // January 20th
  },
);
